import type { ScriptLine } from "../../coldcompute";

// Caption lines are SCENE-LOCAL (fromSec resets to 0 inside each scene's <Sequence>).
// Every claim is grounded in the EAKC achievements record (commits + migrations) —
// see metadata.md GROUNDING NOTE. Anchor: docs/visual-companion/2026-07-19-eakc-achievements.html.
// Tone: build-in-public. Shipped, and here's what's still being measured — not a victory lap.

export const HOOK: ScriptLine[] = [
  { scene: "hook", fromSec: 0.3, holdSec: 4.5, caption: "This week I shipped a quality layer for my AI knowledge product. Here's the honest part: it's on by default, and I can't fully prove it works yet." },
];

export const FLAW: ScriptLine[] = [
  { scene: "flaw", fromSec: 0.4, holdSec: 6, caption: "An answer used to be fluent and still wrong: it dropped facts it had retrieved, and cited a source that didn't exist." },
  { scene: "flaw", fromSec: 6.6, holdSec: 7, caption: "Sometimes it told you to build a feature that already ships. Confident, cited — and only half the story." },
];

export const ANSWERS: ScriptLine[] = [
  { scene: "answers", fromSec: 0.4, holdSec: 6, caption: "So now four checks run before you see a reply. A completeness critic splices back supported facts the first draft dropped." },
  { scene: "answers", fromSec: 6.6, holdSec: 6.5, caption: "A current-state reconciler stops \"you should build X\" when X already exists. The sources footer lists only what was actually cited." },
  { scene: "answers", fromSec: 13.4, holdSec: 5, caption: "And a background auditor samples whether each citation truly supports its claim. All four default to on as of today." },
];

export const CHAT: ScriptLine[] = [
  { scene: "chat", fromSec: 0.4, holdSec: 6, caption: "The transcript behaves. A monotonic order column means a question always sits above its answer — zero ordering violations, verified live." },
  { scene: "chat", fromSec: 6.6, holdSec: 6.5, caption: "Deleting a turn removes the whole turn. Every answer shows its cost — estimated when the provider omits it. And themed diagrams render again." },
];

export const QUIZ: ScriptLine[] = [
  { scene: "quiz", fromSec: 0.4, holdSec: 6, caption: "Generated quizzes leaked a Microsoft course catalog instead of teaching your repo. True/false questions had no buttons. Some were unanswerable." },
  { scene: "quiz", fromSec: 6.6, holdSec: 6.5, caption: "Now the catalog is quarantined, true and false grade correctly, every question is answerable, and a learning path stays anchored to your codebase." },
];

export const CONTROL: ScriptLine[] = [
  { scene: "control", fromSec: 0.4, holdSec: 6, caption: "Nothing runs as a black box. Every quality feature has a real switch in the admin panel — flip it on or off per tenant, no redeploy." },
  { scene: "control", fromSec: 6.6, holdSec: 6.5, caption: "The lesson that made the toggles necessary: a runtime flag needs all four layers — type, storage, API, and a UI control — or it's silently unreachable." },
];

export const HONEST: ScriptLine[] = [
  { scene: "honest", fromSec: 0.4, holdSec: 6.5, caption: "My own rule: a feature is only shipped when its behavior is observable end-to-end. These are. But shipped isn't the same as proven." },
  { scene: "honest", fromSec: 7.2, holdSec: 6.5, caption: "The eval harness that will quantify this is half-built, so the deeper retrieval work is deliberately deferred behind that measurement." },
];

export const OUTRO: ScriptLine[] = [
  { scene: "outro", fromSec: 0.4, holdSec: 5, caption: "So this isn't a victory lap. It's a quality layer that's live, reachable, and on by default — waiting to be measured." },
  { scene: "outro", fromSec: 5.6, holdSec: 4, caption: "Next: the numbers. Proving the layer actually earns its place." },
];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
